import { MutableRefObject, useMemo } from 'react'
import { useSelector } from 'react-redux'

import type { CommentTopic } from 'services/content/types'
import {
  ActionButton,
  PrintButton,
  ShareButton,
  Header,
} from 'ui-component-library/components/CommentsModule'
import { getCommentStrings } from 'store/strings/selectors'
import { getIsLoggedIn, getIsEmailVerified } from 'store/user/selectors'
import copyURLToClipboard from 'utilities/copyURLtoClipboard'

type Props = {
  topics: CommentTopic[]
  selectedTopic?: CommentTopic
  commentsCount: number
  onShowCommentForm: () => void
  commentsRef: MutableRefObject<HTMLDivElement | null>
}

function CommentsHeaderContainer({
  topics,
  selectedTopic,
  commentsCount,
  commentsRef,
  onShowCommentForm,
}: Props) {
  const {
    descriptionText,
    commentsLabelText,
    commentButtonText,
    loginCommentText,
    verifyLink,
    shareText,
    allCommentsUrlCopiedTooltipText,
    printAllText,
    wodText,
  } = useSelector(getCommentStrings)

  const isEmailVerified = useSelector(getIsEmailVerified)
  const isLoggedIn = useSelector(getIsLoggedIn)

  function handleShare() {
    copyURLToClipboard(window.location.href)
  }

  const headlineText = useMemo(() => {
    if (selectedTopic) {
      if (selectedTopic.topicId.startsWith('mainsite')) {
        return `${descriptionText} ${wodText} ${selectedTopic.title}`
      } else {
        return `${descriptionText} ${selectedTopic.title}`
      }
    } else {
      return `${descriptionText} ${topics[0].title}`
    }
  }, [topics, selectedTopic])

  return (
    <Header
      headlineText={headlineText}
      commentsLabelText={commentsLabelText}
      commentsCount={commentsCount}
      actionButtons={
        <>
          <ShareButton
            onClick={handleShare}
            tooltipText={allCommentsUrlCopiedTooltipText}
          >
            {shareText}
          </ShareButton>
          <PrintButton contentRef={commentsRef}>{printAllText}</PrintButton>
        </>
      }
      commentButton={
        <ActionButton
          isEmailVerified={isEmailVerified}
          isLoggedIn={isLoggedIn}
          commentButtonText={commentButtonText}
          loginCommentText={loginCommentText}
          verifyLink={verifyLink}
          onClick={onShowCommentForm}
        />
      }
    />
  )
}

export default CommentsHeaderContainer
